import API, { API_V2 } from '../componentes/restservice/api.instance';
import APIDelete from '../componentes/restservice/apiDelete.instance';
import Config from '../componentes/restservice/Utils';
import { browserHistory } from 'react-router';
import PubSub from 'pubsub-js';
import ModuleApi from './ModuleApi';
import Axios from 'axios';
import { style } from '../style';
import { parseTagsObject, parseObjectTags } from './ParseTags';
import errorHandler from '../componentes/utils/errorHandler';
import NotificationApi from './NotificationApi';

export default class TrailsApi {
  static getAllCourses(page) {
    return (dispatch) => {
      dispatch({ type: 'GET_ALL_COURSES' });
      Axios.get(
        `${style.url.urlClient}api/v2/courses?page=${page}&origin=admin`,
        Config.headers()
      )
        .then((response) => {
          dispatch({
            type: 'GET_ALL_COURSES_SUCCESS',
            courseList: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static getTrails({ page, available }) {
    return (dispatch) => {
      dispatch({ type: 'GET_TRAILS_REQUEST' });

      Axios.get(
        `${style.url.urlClient}/api/v1/trails?origin=web&available=${available}&page=${page}`,

        Config.headers()
      )
        .then((response) => {
          dispatch({
            type: 'GET_TRAILS_SUCCESS',
            trails: response.data,
            page
          });
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static createTrail(values) {
    return (dispatch) => {
      const trailFormData = this.buildTrailFormData(values);

      Axios.post(
        `${style.url.urlClient}/api/v1/trails`,
        trailFormData,
        Config.headers()
      )
        .then((response) => {
          const id = response.data.id;

          dispatch({
            type: 'CREATE_TRAIL',
            trail: response.data
          });

          browserHistory.replace(`/trail/create?id=${id}`);

          dispatch(this.getCurrentTrail(id));
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static updateTrail(id, values) {
    return (dispatch) => {
      const trailFormData = this.buildTrailFormData(values);
      Axios.patch(
        `${style.url.urlClient}/api/v1/trails/${id}`,
        trailFormData,
        Config.headers()
      )
        .then((response) => {
          dispatch({
            type: 'CREATE_TRAIL',
            trail: response.data
          });
          dispatch({
            type: 'OPEN_SUCCESS',
            alert: {
              visible: true,
              message: 'Trilha atualizada com sucesso!'
            }
          });
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static changeAvailableTrail(id, available) {
    return (dispatch) => {
      const formData = new FormData();
      formData.append('available', available ? 1 : 0);

      dispatch({ type: 'UPDATE_TRAIL_AVAILABLE_REQUEST', id });

      Axios.patch(
        `${style.url.urlClient}/api/v1/trails/${id}`,
        formData,
        Config.headers()
      )
        .then((response) => {
          dispatch({
            type: 'UPDATE_TRAIL_AVAILABLE_SUCCESS',
            trail: response.data
          });

          dispatch(this.getTrails({ page: 1, available: true }));
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static deleteTrail(id, avaiable) {
    return (dispatch) => {
      Axios.delete(
        `${style.url.urlClient}/api/v1/trails/${id}`,
        Config.headers()
      )
        .then((response) => {
          dispatch({
            type: 'DELETE_TRAIL'
          });
          dispatch({ type: 'CLOSE_ALERT', alert: { visible: false } });
          dispatch(this.getTrails({ page: 1, available: avaiable }));
        })
        .catch((error) => {
          dispatch({ type: 'CLOSE_ALERT', alert: { visible: false } });
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static getCurrentTrail(id) {
    return (dispatch) => {
      Axios.get(`${style.url.urlClient}/api/v1/trails/${id}`, Config.headers())
        .then((response) => {
          dispatch({
            type: 'GET_CURRENT_TRAIL_COURSES',
            trail: response.data
          });
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static addCourseToTrail(idTrail, idCourseList) {
    return (dispatch) => {
      TrailsApi.executeRequestSequentially(
        idCourseList.map((item) => () => {
          const formData = new FormData();
          formData.append('course_id', item);

          return Axios.post(
            `${style.url.urlClient}/api/v1/trails/${idTrail}/add_course`,
            formData,
            Config.headers()
          );
        })
      )
        .then((response) => {
          dispatch({
            type: 'ADD_COURSE_TO_TRAIL'
          });
          dispatch({
            type: 'OPEN_SUCCESS',
            alert: {
              visible: true,
              message: 'Curso adicionado à trilha com sucesso!'
            }
          });
          dispatch(this.getAllCourses(1));
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static removeCourseFromTrail(idTrail, idCourseList) {
    return (dispatch) => {
      TrailsApi.executeRequestSequentially(
        idCourseList.map((id) => () =>
          Axios.delete(
            `${style.url.urlClient}/api/v1/trails/${idTrail}/remove_course/${id}`,
            Config.headers()
          )
        )
      )
        .then((response) => {
          dispatch({ type: 'REMOVE_COURSE_FROM_TRAIL' });
          dispatch({
            type: 'OPEN_SUCCESS',
            alert: {
              visible: true,
              message: 'Curso removido da trilha com sucesso!'
            }
          });
          dispatch(this.getAllCourses(1));
        })
        .catch((error) => {
          dispatch({
            type: 'OPEN_ERROR',
            alert: {
              visible: true,
              message: errorHandler(error)
            }
          });
        });
    };
  }

  static buildTrailFormData(values) {
    var formData = new FormData();

    formData.append('title', values.title);
    formData.append('description', values.description);

    if (
      values.image &&
      Array.isArray(values.image) &&
      values.image[0] instanceof File
    ) {
      formData.append('image', values.image[0]);
    }

    formData.append(
      'available',
      values.available !== undefined && values.available !== null
        ? values.available
        : true
    );

    if (values.tags && values.tags.length > 0) {
      values.tags.forEach((tag) => {
        formData.append('tag_ids[]', tag.value);
      });
    }

    return formData;
  }

  static executeRequestSequentially(requestList) {
    return new Promise(async (resolve) => {
      for (const callback of requestList) await callback();
      resolve();
    });
  }
}
